import React, { useState, useEffect, useCallback } from "react";
import Header from '../components/Header'
import Footer from '../components/Footer'
import MobileNav from '../components/MobileNav'
import Breadcrumb from '../components/Breadcrumb'
import axios from 'axios';
import Preloader from '../components/Preloader'
import usePageSEO from '../hooks/usePageSEO'

const Contact = () => {
  const [pageLoading, setPageLoading] = useState(true)
  const [metaTitle, setMetaTitle] = useState('')
  const [metaDescription, setMetaDescription] = useState('')
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const apiUrl = apiBaseUrl+`seo?page=contact`;

  const fetchPagedata = useCallback(async () => {
    return axios.get(apiUrl).then((res) => {
      console.log(res.data);
      setMetaTitle(res.data?.meta_title);
      setMetaDescription(res.data?.meta_description);
    });
  },[]); 

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchPagedata();
      setLoading(false);
    }, 1000); // 1 seconds
    return () => clearTimeout(timer);
  }, [fetchPagedata]);

  usePageSEO({
    title: `${metaTitle}`,
    description: `${metaDescription}`
  })  

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [mailMsg, setMailMsg] = useState('');

  const validate = () => {
  const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.phone.trim()) {
        newErrors.phone = "Phone is required";
    }else if (!/^\+?\d*$/.test(formData.phone)) {
        newErrors.phone = "Invalid phone number";
    }
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email";
    }

    if (!formData.message.trim())
      newErrors.message = "Message is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);
    setSuccess(false);
    setMailMsg('');

    const data = new FormData();
    data.append("name", formData.name);
    data.append("phone", formData.phone);
    data.append("email", formData.email);
    data.append("message", formData.message);

    const apiUrl = apiBaseUrl+`send-email`;
    axios.post(apiUrl, formData, {
        headers: {
            'Content-Type': 'multipart/form-data' 
            }
        })
        .then(response => {
            console.log(response.data);
            //if (!response.ok) throw new Error("Failed to send");
            setSuccess(true);
            setMailMsg(response.data);
            setFormData({ name: "", phone: "", email: "", message: "" });
            setLoading(false);
        })
        .catch(error => {
            console.error(error);
            alert("Error sending message");
            setLoading(false);
        }
    );
  };


  return (
    <>
   <div class="page-wrapper">
      <Header />
      <Breadcrumb />
      { loading && ( <Preloader /> )}
      <section class="contact-two">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div class="contact-two__image">
                  <img src="assets/images/shapes/contact-page-1.png" alt="growim" />
                  <div class="contact-two__image__video">
                      <img src="assets/images/resources/contact-page-video.jpg" alt="growim" />
                  </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="contact-two__content">
                <h3 class="contact-two__title">We'll respond to you in an hour.</h3>
                <p class="contact-two__text">We'll respond to you in an hour. Your time matters to us</p>
                <form onSubmit={handleSubmit} class="contact-two__form contact-form-validated form-one wow fadeInUp animated" data-wow-duration="1500ms" action="#" noValidate="novalidate" style={{ visibility: 'visible', animationDuration: '1500ms', animationName: 'fadeInUp' }}>
                    <h4 class="contact-two__form__title">Get In touch</h4>
                    <div class="form-one__group">
                      <div class="form-one__control">
                          <input
                            type="text"
                            name="name"
                            placeholder="Your Name"
                            value={formData.name}
                            onChange={handleChange}
                            />
                            {errors.name && (
                            <p className="text-danger"><small>{errors.name}</small></p>
                            )}
                      </div>
                      <div class="form-one__control">
                        <input
                            type="text"
                            name="phone"
                            placeholder="Phone No."
                            value={formData.phone}
                            onChange={handleChange}
                        />
                        {errors.phone && (
                        <p className="text-danger"><small>{errors.phone}</small></p>
                        )}                                          
                      </div>
                      <div class="form-one__control form-one__control--full">
                        <input
                            type="email"
                            name="email"
                            placeholder="Your Email"
                            value={formData.email}
                            onChange={handleChange}
                        />
                        {errors.email && (
                        <p className="text-danger"><small>{errors.email}</small></p>
                        )}
                      </div>
                      <div class="form-one__control form-one__control--full">
                        <textarea
                            name="message"
                            placeholder="Write Message . . ."
                            value={formData.message}
                            onChange={handleChange}
                        />
                        {errors.message && (
                        <p className="text-danger"><small>{errors.message}</small></p>
                        )}                                          
                      </div>
                      <div class="form-one__control form-one__control--full">
                        <button
                            type="submit"
                            disabled={loading}
                            className="growim-btn"
                            >
                            {loading ? 
                                <span class="growim-btn__text">Sending...</span> 
                                : 
                                <span class="growim-btn__text">Send Message</span>
                            }
                            <span class="growim-btn__icon"><i class="flaticon-up-right-arrow"></i></span>
                        </button>
                      </div>

                      {success && (
                        <div class="form-one__control form-one__control--full">
                            <p className="alert alert-success text-center p-3 mt-3">{mailMsg}</p>
                        </div>
                      )}

                    </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

     <Footer />
    </div>

    <MobileNav />
    </>
  )
}

export default Contact